import * as types from './kpi.types';
import * as constants from './kpi.constants';
import { IMeetingSimple } from '../../resource/meeting-simple/meeting-simple.types';

export const initialKpiPage = (meetingId: IMeetingSimple['id']): types.IInitialKpiPage => ({
  type: constants.INITIAL_KPI_PAGE,
  payload: meetingId,
});
